import { type MCPServerInfo } from '../../types';

const PowerBiServer: MCPServerInfo = {
  serverId: 'POWER_BI',
  name: 'Microsoft Power BI',
  slug: 'power-bi',
  description:
    'Official Microsoft Power BI remote MCP server. Query semantic models, generate DAX queries, and explore data insights using natural language.',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://api.fabric.microsoft.com/v1/mcp/powerbi',
    transport: 'STREAMABLE_HTTP'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  },
  annotations: {
    hintPreRegistered: true
  }
};

export default PowerBiServer;
